export const oneSecondInMs = 1000
export const oneMinuteInMs = oneSecondInMs * 60
export const oneHourInMs = oneMinuteInMs * 60
export const oneDayInMs = oneHourInMs * 24
export const oneWeekInMs = oneDayInMs * 7

export const oneMinuteInSeconds = 60
export const oneHourInSeconds = oneMinuteInSeconds * 60
export const oneDayInSeconds = oneHourInSeconds * 24
export const oneWeekInSeconds = oneDayInSeconds * 7

export function getDuration(from: Date, to: Date) {
    return from.getTime() - to.getTime()
}
